import React from 'react'

export const BranchMarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="34"
    height="48"
    viewBox="0 0 34 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.8749 0C7.56541 0 0 7.56559 0 16.8749C0 20.0249 0.872059 23.0906 2.53133 25.7344L15.731 47.3356C15.9562 47.7012 16.2937 47.9263 16.6875 47.9826C17.2217 48.0668 17.8126 47.8419 18.1219 47.3076L31.3593 25.5093C32.9342 22.9219 33.7499 19.9125 33.7499 16.8749C33.7499 7.56559 26.1845 0 16.8749 0ZM16.8749 25.3124C12.1501 25.3124 8.43747 21.4874 8.43747 16.8749C8.43747 12.2342 12.2342 8.43747 16.8749 8.43747C21.5156 8.43747 25.3124 12.2342 25.3124 16.8749C25.3124 21.4593 21.6561 25.3124 16.8749 25.3124Z"
      fill="#9CA3AF"
    />
    <path
      d="M16.875 0V8.43747C21.5157 8.43747 25.3125 12.2342 25.3125 16.8749C25.3125 21.4593 21.6561 25.3124 16.875 25.3124V47.999C17.3549 48.0101 17.8484 47.7801 18.1219 47.3076L31.3593 25.5093C32.9342 22.9219 33.7499 19.9125 33.7499 16.8749C33.7499 7.56559 26.1845 0 16.875 0Z"
      fill="#6B7280"
    />
  </svg>
)
